<script lang="ts">
	import { getTranslate } from "../utils/getTranslate.js";
	import Link from "./Link.svelte";
	import translations from "./CareerSection.translations.json";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import type { Position } from "../../../core/schema/Position.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { getCareerDetailPath } from "../../../core/schema/paths/getCareerDetailPath.js";

	export let position: Position;
	export let showLabels = true;

	const translate = getTranslate(translations);
</script>

<div class="border-lttertiary relative z-10 [&:last-child>div]:border-b-0">
	<div
		class="border-lttertiary flex flex-col gap-3 border-b bg-white px-4 py-5 md:px-8 lg:h-24 lg:flex-row lg:items-center lg:gap-6 lg:py-0"
	>
		<div class="flex items-center gap-3 lg:contents">
			<p
				class="font-lexend text-ltsecondary !text-base/tighter md:!text-md/none !mb-0 min-w-0 flex-1 font-light lg:w-[49rem]"
			>
				{nbspify(position.name)}
			</p>

			<Link
				asButton
				variant="tertiary"
				class="shrink-0 uppercase lg:hidden"
				icon={arrowRight}
				href="/{getCareerDetailPath(position)}"
			>
				{translate("detail")}
			</Link>
		</div>

		{#if showLabels && position.labels.length > 0}
			<div class="flex flex-wrap items-center gap-2 self-start lg:gap-3 lg:self-auto">
				{#each position.labels as label (label)}
					<span
						class="bg-lttertiary-100 text-ltprimary-300 font-bahnschrift !text-2xs px-[0.313rem] py-1 font-normal uppercase leading-none tracking-wider"
					>
						{nbspify(label)}
					</span>
				{/each}
			</div>
		{/if}

		<Link
			asButton
			variant="tertiary"
			class="ml-auto hidden shrink-0 uppercase lg:inline-flex"
			icon={arrowRight}
			href="/{getCareerDetailPath(position)}"
		>
			{translate("detail")}
		</Link>
	</div>
</div>
